import APICallLogs from "./APICallLog";

export default APICallLogs;
